import { useLocation, useParams } from "react-router-dom";
import { MerchantHeader, ProductsList } from "../../components";
import { useQuery } from "@tanstack/react-query";
import { getStoreProfile } from "../../services/api";
import { usePayLinkCart } from "../../context/PayLinkCartContext";
import { useEffect } from "react";

export const PayLinkStore = () => {
  const location = useLocation();
  const { storeSlug, variantUrn } = useParams();
  const { setStoreProfile } = usePayLinkCart();
  const { data: store_data } = useQuery({
    queryKey: ["GetStoreProfile", storeSlug],
    queryFn: () =>
      getStoreProfile({
        Slug: storeSlug ?? "",
      }),
    enabled: !!storeSlug,
  });
  const store_profile = store_data && store_data?.data && store_data.data[0];
  useEffect(() => {
    if (store_profile) {
      setStoreProfile(store_profile);
    }
  }, [store_profile, setStoreProfile]);

  useEffect(() => {
    localStorage.setItem("paylink_entry_path", location.pathname);
  }, [location.pathname]);

  return (
    <section className="flex flex-col w-full !container !pb-20">
      <MerchantHeader />
      <ProductsList
        storeProfile={store_profile}
        productVariantUrn={variantUrn}
      />
    </section>
  );
};
